import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import GoogleMapsComponent from './GoogleMaps2'
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';



const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));


const AddressComponent = ({
  type,
  onChange,
  disabled,
  onPleaceSearch,
  value,
  error,
  children,
  title,
  places,
  address_types,
  address_data,
  onRemoveItem,
  ...props
}) => {


  const handleChange = event => {
    onChange(event, 'address_data')
  }

  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      <div className="row">
        <div className="col col-md-6">
          <GoogleMapsComponent 
             height='300px'
             onChange={onPleaceSearch}
             places={places}
             disabled={disabled}
             zoom={15}/>
        </div>
        <div className="col col-md-6">
        { places.map((val, idx) => {
            var address_leyend = ''
            /*if(val[0].formatted_address !== undefined){
              address_leyend = val[0].formatted_address
              if (address_data[idx].street_number !== undefined){
                if (val[0].address_components[0].long_name === 'S/N' && (!val[0].formatted_address.includes(address_data[idx].street_number) ) ){
                  address_leyend = val[0].formatted_address.replace(val[0].address_components[1].short_name,
                        val[0].address_components[1].short_name +' '+ address_data[idx].street_number                    
                      )              
                }
              }
            } else {
              if (address_data[idx].street !== undefined && address_data[idx].number !== undefined){
                address_leyend = address_data[idx].street + '-' + address_data[idx].number
              }
            }*/
            if (address_data[idx]){
              if (address_data[idx].formattedAddress) {
                address_leyend = address_data[idx].formattedAddress   
              } else {
                address_leyend = val[0].formatted_address
                if (address_data[idx].street_number !== undefined){
                  if (val[0].address_components[0].long_name === 'S/N' && (!val[0].formatted_address.includes(address_data[idx].street_number) ) ){
                    address_leyend = val[0].formatted_address.replace(val[0].address_components[1].short_name,
                          val[0].address_components[1].short_name +' '+ address_data[idx].street_number                    
                        )              
                  }
                }
              }
            }
            return (
                <div>
                  <div><Typography variant="caption">{(address_leyend) ? address_leyend : 'Se actualizará la dirección al agregar el código de domicilio.'}</Typography></div>
                
                

                  {
                    (val[0].address_components !== undefined)
                      ?
                        (val[0].address_components[1].short_name === 'AR')
                      ?
                        <React.Fragment>
                          <TextField
                              id={"street."+idx}
                              name={"street."+idx}
                              dataid={idx}
                              disabled={disabled}
                              type="text"
                              placeholder="Calle"
                              label="Calle"
                              onChange={handleChange}
                              value={address_data[idx].street}
                              helperText= {(error !=='' && address_data[idx].street ==='' ) ? 'Debe completar este valor' : ''}
                              error={(error !=='' && address_data[idx].street ==='') ? 'Debe completar este campo' :  false }
                              className="mr-1"
                              InputLabelProps={{
                                shrink: true
                              }}
                              inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                          />
                        </React.Fragment>
                      :
                      ''
                    :
                    ''
                  }

                  {
                    (val[0].address_components !== undefined)
                      ?
                        (val[0].address_components[0].long_name === 'S/N')
                      ?
                        <React.Fragment>
                          <TextField
                            id={"street_number."+idx}
                            name={"street_number."+idx}
                            dataid={idx}
                            disabled={disabled}
                            type="text"
                            placeholder="Altura"
                            label="Altura"
                            onChange={handleChange}
                            value={address_data[idx].street_number}
                            helperText= {(error !=='' && address_data[idx].street_number ==='' ) ? 'Debe completar este valor' : ''}
                            error={(error !=='' && address_data[idx].street_number ==='') ? 'Debe completar este campo' :  false }
                            className="mr-1"
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                          />
                        </React.Fragment>
                      :
                      ''
                    :
                    ''
                  }
                  {
                    (val[0].address_components !== undefined)
                      ?
                        (!val[0].address_components[6])
                      ?
                          <TextField
                          id={"postal_code."+idx}
                          name={"postal_code."+idx}
                          dataid={idx}
                          disabled={disabled}
                          type="text"
                          placeholder="Cod Postal"
                          label="Cod Postal"
                          onChange={handleChange}
                          value={address_data[idx].postal_code}
                          helperText= {(error !=='' && address_data[idx].postal_code ==='' ) ? 'Debe completar este valor' : ''}
                          error={(error !=='' && address_data[idx].postal_code ==='') ? 'Debe completar este campo' :  false }
                          className="mr-1"
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                        />

                      :
                      ''
                    :
                    ''
                  }

                <div>
                  <TextField
                    id={"floor."+idx}
                    name={"floor."+idx}
                    dataid={idx}
                    disabled={disabled}
                    type="text"
                    placeholder="Piso"
                    label="Piso"
                    onChange={handleChange}
                    value={address_data[idx].floor}
                    className="mr-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                  />
                  <TextField
                    id={"departament."+idx}
                    name={"departament."+idx}
                    dataid={idx}
                    disabled={disabled}
                    type="text"
                    placeholder="Dpto"
                    label="Dpto"
                    onChange={handleChange}
                    value={address_data[idx].departament}
                    className="mr-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                  />
                  <TextField
                    id={"others."+idx}
                    name={"others."+idx}
                    dataid={idx}
                    disabled={disabled}
                    type="text"
                    placeholder="Otros"
                    label="Otros"
                    onChange={handleChange}
                    value={address_data[idx].others}
                    className="mr-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                  />
                  
                </div>
                <TextField
                  id={"code."+idx}
                  name={"code."+idx}
                  dataid={idx}
                  disabled={disabled}
                  type="text"
                  placeholder="Código Domicilio"
                  label="Cod. Domicilio"
                  onChange={handleChange}
                  value={address_data[idx].code}
                  helperText= {(error !=='' && address_data[idx].code ==='' ) ? 'Debe completar este valor' : ''}
                  error={(error !=='' && address_data[idx].code ==='') ? 'Debe completar este campo' :  false }
                 className="mr-1"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{style:{minWidth: 50, fontSize: '0.75rem'}}} 
                />

                <FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name={"type."+idx} ><Typography className={classes.typography}>Tipo de dirección *</Typography>
                  <Select native name={"type."+idx}
                      inputProps={{
                        name:"type."+idx,
                        className:"type."+idx
                      }}
                      data-id={idx}
                      style={{minWidth: 150, fontSize: '0.75rem'}}
                      onChange={handleChange}
                      value={address_data[idx].type}
                      disabled={disabled}
                      error={(error !=='' && address_data[idx].type ==='') ? 'Debe completar este campo' :  false }
                      input={<Input id="grouped-native-select" name={"type."+idx} /> }>
                      <option value="" />
                      {address_types.map((address_type) => <option id={address_type.id} value={address_type.id}>{address_type.name}
                    </option>)}
                  </Select>
                  {(error !=='' && address_data[idx].type ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
                </FormControl>
                {(!disabled)?
                  <IconButton size="small" onClick={onRemoveItem(idx)} disabled={disabled} >
                    <RemoveIcon />
                  </IconButton>
                  :
                  ''}
              </div>
            )
          })
        }
      </div>
      </div>
      { error && <p style={{color: 'red'}}>{ error }</p>}
    </React.Fragment>
  )
}

AddressComponent.defaultProps = {
  type: "text",
  className: "",
  places:[],
  disabled: false
}

AddressComponent.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default AddressComponent;